import {Directive, ElementRef, Output, EventEmitter} from "@angular/core";
import {NgForm} from "@angular/forms";
const $ = require('jquery');

@Directive({
    selector: '[form-trigger]'
})
export class FormTrigger {

    @Output('form-trigger')
    formTrigger: EventEmitter<any> = new EventEmitter<any>();

    private formEl: any;
    private triggerEl: any;

    constructor(private form: NgForm, private el: ElementRef) {
    }

    ngOnInit() {
        this.formEl = $(this.el.nativeElement).closest('form');
        this.triggerEl = this.formEl.find('[type="submit"]');
        if (!this.triggerEl.length) {
            this.triggerEl = $('<input type="submit" hidden/>');
            this.formEl.append(this.triggerEl);
        }
        const that = this;
        this.triggerEl.eq(this.triggerEl.length - 1).bind('click', () => {
            that.formTrigger.emit(true);
        });
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/form/form.trigger.ts